import { validateHedString, validateHedEvent, validateHedEventWithDefinitions } from './init'

import { HedValidator } from './validator'
import { Hed3Validator } from './hed3'
import { Hed2Validator } from '../hed2/event/hed2Validator'

export {
  validateHedString,
  validateHedEvent,
  validateHedEventWithDefinitions,
  HedValidator,
  Hed2Validator,
  Hed3Validator,
}

export default {
  validateHedString,
  validateHedEvent,
  validateHedEventWithDefinitions,
  HedValidator,
  Hed2Validator,
  Hed3Validator,
}
